import React from 'react';
import { Helmet } from 'react-helmet'

import { Lines, Planets, Cube, Ripple } from 'react-preloaders2';
import Ticket from "../../blocks/ticket/Ticket";
import './assets/css/index.css';

import TriangleAnimated from "../../blocks/triangle/TriangleAnimated";
import PagePreloader from "../../helpers/PagePreloader";
import { withTranslation, Trans } from 'react-i18next';
import GalleryGrid from './components/GalleryGrid';



class Gallery extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      currentTab: 0
    };

  }

  componentDidMount() {

    this.setState({ loading: false });

  }


  onTabClick = (tab) => {
    this.setState({
      currentTab: tab
    })
  }


  render() {
    return (
      <React.Fragment>

        <Helmet>
          <title>{this.props.pageTitle}</title>
        </Helmet>

        <section id="gallery" className="inner-wrapper">
          <h1>{this.props.t('Gallery')}</h1>


            <TriangleAnimated right />
            <TriangleAnimated left />
            <TriangleAnimated right bottom />
            <TriangleAnimated left bottom />


          <div className="container">
            <div className="body">
              {this.props.t('Erlebe das alba Festival nochmal in Bildern.')}
            </div>
          </div>


          <div className="container">
            <div className="headline">
              <h2>2022</h2>
            </div>
            <ul className="nav nav-tabs" id="gallery-tabs" role="tablist">
              <li className="nav-item" role="presentation">
                <button onClick={() => this.onTabClick(0)} className="nav-link active" id="gallery-sa-tab" data-bs-toggle="tab" data-bs-target="#gallery-sa-tab-pane" type="button" role="tab" aria-controls="gallery-sa-tab-pane" aria-selected="true">Gallery SA</button>
              </li>
              <li className="nav-item" role="presentation">
                <button onClick={() => this.onTabClick(1)} className="nav-link" id="gallery-so-tab" data-bs-toggle="tab" data-bs-target="#gallery-so-tab-pane" type="button" role="tab" aria-controls="gallery-so-tab-pane" aria-selected="true">Gallery SO</button>
              </li>
              <li className="nav-item" role="presentation">
                <button onClick={() => this.onTabClick(2)} className="nav-link" id="cube-sa-tab" data-bs-toggle="tab" data-bs-target="#cube-sa-tab-pane" type="button" role="tab" aria-controls="cube-sa-tab-pane" aria-selected="true">Cube SA</button>
              </li>
              <li className="nav-item" role="presentation">
                <button onClick={() => this.onTabClick(3)} className="nav-link" id="cube-so-tab" data-bs-toggle="tab" data-bs-target="#cube-so-tab-pane" type="button" role="tab" aria-controls="cube-so-tab-pane" aria-selected="true">Cube SO</button>
              </li>
            </ul>
            <div className="tab-content" id="gallery-tab-content">
              <div className="tab-pane fade show active" id="gallery-sa-tab-pane" role="tabpanel" aria-labelledby="gallery-sa-tab" tabindex="0">

                {this.state.currentTab == 0 &&
                  <GalleryGrid uuid={'c1920f94-fbef-4235-8756-c5d191baf66c'} />
                }

              </div>
              <div className="tab-pane fade" id="gallery-so-tab-pane" role="tabpanel" aria-labelledby="gallery-so-tab" tabindex="0">


                  {this.state.currentTab == 1 &&
                    <GalleryGrid uuid={'09f43d5e-1af4-4152-9c3a-03f5700f6b8d'} />
                  }

              </div>
              <div className="tab-pane fade" id="cube-sa-tab-pane" role="tabpanel" aria-labelledby="cube-sa-tab" tabindex="0">


                  {this.state.currentTab == 2 &&
                    <GalleryGrid uuid={'ff22e768-8285-402f-ac22-1591da4c7fcd'} />
                  }

              </div>
              <div className="tab-pane fade" id="cube-so-tab-pane" role="tabpanel" aria-labelledby="cube-so-tab" tabindex="0">


                  {this.state.currentTab == 3 &&
                    <GalleryGrid uuid={'5c77b073-53e4-42f4-b6b2-e95a3d4bf66b'} />
                  }

              </div>
            </div>
          </div>




          <Ticket />

        </section>


        <PagePreloader page={this} />

      </React.Fragment>
    );
  }
}


export default withTranslation()(Gallery);
